// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__kwwXj","fileBtn":"File_fileBtn__tJUkf","closeBtn":"File_closeBtn__3JKt5","fileSelected":"File_fileSelected__1kul8","disabled":"File_disabled__2XMo4"};